export default __webpack_public_path__ + "static/media/member-martin.63f0bfb3.jpg";